// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-next',
  revision: '51550e6ee',
  branch: 'next',
  date: 'Mon, 22 Jun 2026 15:29:47 GMT'
};